import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'custom-zenith-form-group-error',
  template: `
    <zenith-form-group-error>
      @for (error of errors; track error.key) {
        {{ error.key | translate : error.args }}<br />
      }
    </zenith-form-group-error>
  `,
  standalone: true,
  imports: [ZenithComponentsModule, TranslateModule]
})
export class CustomZenithFormGroupErrorComponent {
  @Input() control: AbstractControl;

  get errors(): { key: string; args: any[] }[] {
    return Object.entries(this.control.errors || []).map(([key, value]) => ({
      key: `validators.${key}`,
      args: value
    }));
  }
}
